import { centerable as t } from "../decorators/centerable.js";
import { stylable as e } from "../decorators/stylable.js";
import { BLOCK_CLASSES as o } from "../../constants.js";
const a = e(
  t({
    content: "",
    group: "block",
    attrs: {
      type: { default: "social" },
      items: {},
      alignment: {}
    },
    toDOM(r) {
      return [
        "div",
        {
          class: `${o.blockContainer} ${o.social} intercom-social-container`
        }
      ];
    }
  })
);
export {
  a as socialSpec
};
